import { Component, Input } from '@angular/core';

@Component({
  selector: 'prada-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss'],
})
export class NoDataComponent {
  @Input() message = 'COMMON.LABEL.NO_DATA_FOUND';
}
